import { DateRange } from "@material-ui/lab/DateRangePicker";
import moment from "moment";
import React from "react";
import DateRangeField from "../../../components/DateRangeField";
import useFilterValue from "../Provider/hooks/useFilterValue";
import { FieldDatesFC } from "./types";

const FieldDates: FieldDatesFC = () => {
  const fromDate = useFilterValue("fromDate");
  const toDate = useFilterValue("toDate");
  const handlerChange = ([from, to]: DateRange<Date>) => {
    fromDate.filterUpdate({
      ...fromDate.filter,
      fromDate: moment(from) ?? moment(),
      toDate: moment(to) ?? moment(),
    });
  };
  return (
    <DateRangeField
      fromDate={fromDate.value?.toDate() ?? new Date()}
      toDate={toDate.value?.toDate() ?? new Date()}
      onChange={handlerChange}
      onAccept={console.log}
    />
  );
};

export default FieldDates;
